import PropTypes from 'prop-types';
import React from 'react';
import Glyphicon from '../Glyphicon/index.js';

/**
 *  FormElementFeedback renders the remove icon to a form element, such as Input, Checkbox, etc
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function FormElementFeedback(_ref) {
  let {
    show,
    onFeedbackClick
  } = _ref;
  return show && /*#__PURE__*/_jsx(Glyphicon, {
    "data-cmp": "form-element-feedback",
    className: "form-control-feedback interactive cursor-pointer text-gray-muted",
    glyph: "remove",
    onClick: onFeedbackClick
  });
}
export default FormElementFeedback;